import type { ReferenceWithCount } from '../types';

interface CategoryFilterProps {
  selectedId: string | null;
  onChange: (id: string | null) => void;
  categories?: ReferenceWithCount[];
  loading?: boolean;
}

export function CategoryFilter({ selectedId, onChange, categories = [], loading = false }: CategoryFilterProps) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide" role="group" aria-label="Filtrar por categoría">
      <button
        type="button"
        onClick={() => onChange(null)}
        className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
          !selectedId
            ? 'bg-gray-900 text-white shadow-sm'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        Todas
      </button>
      {loading &&
        [1, 2, 3, 4].map((i) => (
          <span key={i} className="skeleton h-9 w-24 rounded-full flex-shrink-0" />
        ))}
      {!loading &&
        categories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => onChange(cat.id)}
            className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
              selectedId === cat.id
                ? 'bg-gray-900 text-white shadow-sm'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {cat.name}
            {cat.recommendationCount > 0 && (
              <span className={`ml-1.5 text-xs ${selectedId === cat.id ? 'text-gray-300' : 'text-gray-400'}`}>
                {cat.recommendationCount}
              </span>
            )}
          </button>
        ))}
    </div>
  );
}